<template>
<!-- loading spinner -->
<div class="ship-modal-cover ship-modal-spinner">
    <span class="icon-spinner icon-action-rotate"></span>
</div>
</template>
<script>
export default {
  name: 'LoadingSpinner'
}
</script>
<style scoped lang="scss">
</style>